module.exports = {"500238001":"宁河街道","500238002":"柏杨街道","500238100":"城厢镇","500238101":"凤凰镇","500238102":"宁厂镇","500238103":"上磺镇","500238104":"古路镇","500238105":"文峰镇","500238106":"徐家镇","500238107":"白鹿镇","500238108":"尖山镇","500238109":"下堡镇","500238110":"峰灵镇","500238111":"塘坊镇","500238112":"朝阳镇","500238113":"田坝镇","500238114":"通城镇","500238115":"菱角镇","500238116":"蒲莲镇","500238117":"土城镇","500238118":"红池坝镇","500238204":"胜利乡","500238207":"大河乡","500238208":"天星乡","500238210":"长桂乡","500238226":"鱼鳞乡","500238227":"乌龙乡","500238237":"花台乡","500238239":"兰英乡","500238240":"双阳乡","500238242":"中梁乡","500238243":"天元乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/500238.json
// module id = 2377
// module chunks = 0